var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3089_12918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.906 78.0798C144.344 78.0798 139.812 82.603 139.812 88.1556V109.337C139.812 125.059 126.781 137.848 110.781 137.848H49.2188C33.2188 137.848 20.1875 125.059 20.1875 109.337V48.6634C20.1875 32.9414 33.2188 20.1516 49.2188 20.1516H71.0938C76.6562 20.058 81.125 15.4725 81 9.88865C80.9062 4.492 76.5312 0.0935834 71.0938 0H49.2188C22.0938 0 0 21.8361 0 48.6634V109.337C0 136.164 22.0938 158 49.2188 158H110.781C137.938 158 160 136.164 160 109.337V88.1556C160 82.603 155.5 78.0798 149.906 78.0798Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.687 54.6528L68.2183 78.2982C67.187 83.7572 70.812 89.0291 76.2808 90.0585C76.9058 90.1833 77.4995 90.2456 78.1245 90.2456C78.7495 90.2456 79.3745 90.1833 79.9995 90.0585L103.687 85.5977C105.687 85.2233 107.531 84.2563 108.968 82.8214L153.75 38.1197C157.843 34.0332 159.343 28.0439 157.875 21.6802C156.781 16.9074 154.031 12.1971 150.156 8.29777C146.281 4.39846 141.5 1.65334 136.718 0.561537C130.343 -0.904603 124.343 0.592732 120.25 4.67921L75.4683 49.4121C74.0308 50.847 73.062 52.6563 72.687 54.6528ZM91.937 61.4531L133 20.4948C134.062 20.9939 135.062 21.6802 135.875 22.5536C136.718 23.3647 137.437 24.3629 137.937 25.4235L96.8745 66.3819L90.812 67.5361L91.937 61.4531Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3089_12918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 158,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3dd1e1a8.svg";
export { ForwardRef as ReactComponent };